var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrawConsultScheduled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 388,
    viewBox: "0 0 402 388",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H402V270.874H0V0Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.729 56.2771H274.863",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.729 71.6812H269.698",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.331 271.461V0.591553",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 1.18075,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.661 271.461V0.591553",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 1.18075,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.992 271.461V0.591553",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 1.18075,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.695 372.205L176.583 382.622L185.719 382.842L184.024 371.814L175.695 372.205Z",
    fill: "#E49D75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4432 353.633L88.2011 367.949L92.5335 372.461L100.22 359.929L92.4432 353.633Z",
    fill: "#E49D75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.029 380.28L174.863 388L198.811 387.855C198.977 387.965 198.856 384.07 198.856 384.07L184.606 380.17L175.029 380.28Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8752 365.498L83.0114 372.13L93.1803 386.526L102.788 386.591L102.657 381.729L98.8063 380.025L95.3916 371.558L87.8752 365.498Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.049 73.3452H230.832V120.113H184.049V73.3452Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.049 73.3452H230.832V83.7916H184.049V73.3452Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.236 129.016C132.673 128.479 141.348 128.71 143.669 127.467C145.991 126.224 174.648 104.76 177.531 101.837C180.414 98.9148 183.979 96.3784 186.556 93.2003C189.134 90.0223 186.642 98.8296 184.39 100.564C184.13 102.92 184.064 107.852 184.064 107.852C183.468 107.748 182.857 107.77 182.27 107.917C181.684 108.065 181.135 108.335 180.66 108.71C179.035 109.983 155.538 137.628 155.538 137.628C155.538 137.628 127.799 129.557 130.236 129.016Z",
    fill: "#E49D75"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.95 211.604C107.496 217.118 104.693 255.716 113.313 275.025C109.572 289.145 90.573 354.951 90.573 354.951L100.02 363.272L148.719 289.586C148.719 289.586 138.58 208.978 108.95 211.604Z",
    fill: "#34BBC4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.672 209.218C160.643 214.697 180.78 286.579 180.78 286.579L185.333 373.894L174.913 374.716L142.546 286.794C138.595 282.318 113.493 222.236 112.365 214.527C117.299 209.284 156.701 203.735 158.672 209.218Z",
    fill: "#2DA2AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.439 125.532C126.405 125.532 148.869 130.976 153.091 139.748C155.413 144.57 165.597 203.524 159.941 212.792C154.284 222.061 115.313 221.665 107.712 214.677C103.435 210.757 102.056 125.502 122.439 125.532Z",
    fill: "#2B45D4",
    fillOpacity: 0.04
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H402V36.2616H0V0Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.628 57.5002H81.0257",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.464 115.497H126.069V132.189C122.975 134.65 117.464 132.189 117.464 132.189V115.497Z",
    fill: "#E49D75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.458 100.409C106.458 90.0075 113.523 81.5762 122.243 81.5762C130.963 81.5762 138.023 90.0075 138.023 100.409C138.023 110.81 130.958 119.246 122.243 119.246C113.528 119.246 106.458 110.81 106.458 100.409Z",
    fill: "#E49D75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.343 78.4781C125.397 78.3628 131.821 81.5759 131.821 83.8066C131.821 87.6663 125.833 96.4184 121.376 100.007C122.624 102.89 123.768 104.795 123.768 107.241C123.768 109.687 119.962 119.271 119.962 125.788C119.962 130.901 121.105 134.379 121.105 138.62C121.105 150.204 113.543 157.217 102.607 157.217C91.6711 157.217 84.3252 145.362 84.2801 135.738C84.2249 123.938 97.3172 109.456 100.491 100.559C103.164 93.0499 108.223 78.4781 120.343 78.4781Z",
    fill: "#FFDD00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.003 101.381C117.003 100.6 117.235 99.8358 117.669 99.1861C118.104 98.5364 118.721 98.0302 119.444 97.7314C120.166 97.4325 120.961 97.3546 121.727 97.5074C122.494 97.6602 123.198 98.0369 123.75 98.5898C124.303 99.1428 124.678 99.8471 124.83 100.614C124.982 101.38 124.903 102.175 124.603 102.896C124.304 103.618 123.796 104.234 123.146 104.668C122.496 105.101 121.731 105.332 120.949 105.331C120.431 105.331 119.917 105.229 119.438 105.03C118.959 104.832 118.524 104.541 118.157 104.174C117.791 103.807 117.5 103.372 117.302 102.892C117.104 102.413 117.003 101.9 117.003 101.381Z",
    fill: "#E49D75"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.509 157.578C163.942 158.631 182.099 161.673 185.584 160.586C189.069 159.498 224.971 125.272 227.769 122.74C230.567 120.209 236.183 116.625 236.86 112.244C237.537 107.863 236.86 104.113 230.772 101.918C230.888 104.745 230.998 109.156 230.878 108.499C229.85 105.091 229.729 101.226 227.869 101.271C226.866 104.459 228.28 110.469 225.813 114.494C222.98 117.572 185.353 142.254 181.402 143.503C176.247 143.503 163.029 138.991 163.029 138.991C163.029 138.991 155.082 156.525 159.509 157.578Z",
    fill: "#E49D75"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.04 139.898C133.109 127.016 160.031 133.828 164.559 137.442C166.143 142.349 163.651 156.906 159.695 159.608C153.753 160.47 126.771 153.603 130.04 139.898Z",
    fill: "#2B45D4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.628 84.9246H65.7622",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.628 132.038H44.1758",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.628 149.813H65.7622",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.628 165.217H60.5975",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M318.312 55.3147H380.709",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M318.312 72.4028H361.936",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M318.312 90.5837H376.909",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M318.312 107.125H347.846",
    stroke: "white",
    strokeWidth: 15.3262,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.067 94.4385H199.007L195.868 96.0977L195.397 94.253L199.318 92.1577H201.384V110.083H199.067V94.4385Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.57 92.1777V93.7768L211.758 110.103H209.251L217.028 94.243V94.1878H208.258V92.1828L219.57 92.1777Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawConsultScheduled);
export default __webpack_public_path__ + "static/media/drawConsultScheduled.bdba314a4c0fbf58594cb3500f685340.svg";
export { ForwardRef as ReactComponent };